import Head from "next/head";

export default () => (
    <Head>
        <title>Argentum Online Web</title>
        <meta
            name="viewport"
            content="width=device-width,initial-scale=1.0,user-scalable=no,minimum-scale=1.0,maximum-scale=1.0"
        />
        {/* Cinzel — usada EXCLUSIVAMENTE por el logo ARGENTUMONLINEWEB
            del navbar (components/header). Trajan-style serif fantasy,
            espeja la tipografía del PNG /static/imgs/aoweb-logo.png.
            En el resto del proyecto se usa Doppio One (default) o las
            AcciaPiano variants. */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="anonymous"
        />
        <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700;800&display=swap"
        />
    </Head>
);
